import { supabase } from '../../../lib/supabase';

/** Limpa artefatos comuns da resposta do Gemini (análise de vendas). */
export const cleanGeminiResponse = (text: string): string => {
    if (!text) return text;
    return text
        .replace(/\[object Object\]/gi, '')
        .replace(/```[\s\S]*?```/g, '')
        // Remove backticks mas preserva o conteúdo (ex.: {{perda|...}})
        .replace(/`([^`]*)`/g, '$1')
        .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '[ID Removido]')
        // Remove emojis (apresentação limpa no modal)
        .replace(/\p{Extended_Pictographic}/gu, '')
        // Normaliza headings: ### / #### → ##
        .replace(/^#{3,}\s*/gm, '## ')
        .replace(/^#\s+/gm, '## ')
        .replace(/\n{3,}/g, '\n\n')
        .replace(/leads/gi, 'clientes potenciais')
        .replace(/lead/gi, 'cliente potencial')
        .replace(/[ \t]+\n/g, '\n')
        .trim();
};

/** Remove cercas ```opcional``` mantendo o conteúdo interno. */
export const stripCodeFences = (text: string): string => {
    const trimmed = text.trim();
    const fenced = trimmed.match(/^```(?:\w+)?\s*\n?([\s\S]*?)\n?```$/);
    if (fenced) return fenced[1].trim();
    return trimmed.replace(/```html/gi, '').replace(/```/gi, '').trim();
};

/** Único ponto de integração com a edge function gemini-proxy. */
export const callGeminiProxy = async (
    prompt: string,
    generationConfig: Record<string, unknown> = {}
): Promise<string> => {
    const { data, error } = await supabase.functions.invoke('gemini-proxy', {
        body: { prompt, model: 'gemini-2.5-flash-lite', generationConfig },
    });

    if (error) {
        const bodyError =
            data && typeof data === 'object' && 'error' in data
                ? String((data as { error?: unknown }).error ?? '')
                : '';
        const msg =
            bodyError ||
            (error as { context?: { error?: string } })?.context?.error ||
            error.message ||
            'Erro ao contactar serviço de IA.';
        throw new Error(msg);
    }

    const text = data?.text ?? '';
    if (!text) throw new Error('Gemini gerou uma resposta vazia.');

    return text;
};
